import React from 'react'
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';

gsap.registerPlugin(useGSAP);

//only apply for layer with animation, not include texts
function useLayerAnimation(setting: any, canPlay: boolean, pageSize: [number, number] = [1920, 1080]) {
    const container = React.useRef(null);
    const animation = setting?.animation || {};

    const {duration, x, y, ease, strength, type, yoyo, loop, fade} = animation;


    useGSAP(() => {
        if(!animation || !container.current) return;
        const config = getConfig(animation, pageSize);
        const repeat = animation.loop ? -1 : 0;
        const tl = gsap.timeline({ repeat, paused: true, yoyo, repeatDelay: 0.5 });
        const target = container.current;
        tl.from(target, {
            ...config,
            duration: animation.duration || 1,
            delay: animation.delay || 0,
            ease: animation.ease || 'none',
        });

        if (canPlay) {
            tl.play(0);
        }
    }, {dependencies: [duration, x, y, ease, strength, type, canPlay, yoyo, loop, fade], scope: container, revertOnUpdate: true })

    return container;
}

export default useLayerAnimation

const getConfig = (animation, pageSize): gsap.TweenVars => {
    const [pageW, pageH] = pageSize;
    const x = animation.x || 0;
    const y = animation.y || 0;
    const isPortrait = pageW < pageH;
    const ratioWidth = pageW / (isPortrait ? 1080 : 1920);
    const ratioHeight = pageH / (isPortrait ? 1920 : 1080);
    const relativeX = x * ratioWidth;
    const relativeY = y * ratioHeight;

    switch (animation.type) {
        case 'move': {
            return {
                x: relativeX,
                y: relativeY,
                opacity: animation.fade ? 0 : 1,
            }
        }
        case 'fade': {
            return {
                opacity: 0,
            }
        }
        case 'rotate': {
            return {
                rotation: (animation.strength || 0) * 180,
            }
        }
        case 'zoom': {
            return {
                scale: 1 + (((animation.strength|| 0) * 2 )/10),
            }
        }
        case 'roll': {
            return {
                x: relativeX,
                y: relativeY,
                rotation: 360 * (animation.x < 0 ? -1 : 1),
                opacity: animation.fade ? 0 : 1,
            }
        }
        case 'flip': {
            return {
                rotationY: animation.strength * 180,
            }
        }

        default: return null;
    }
}